import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllAttributeValue = async (params) => {
    let query = new URLSearchParams(params).toString();
    const response = await api.get(`${endpoints.AttributeValues.GetAllAttributeValues}?${query}`);
    return {
        data: response.data.data || [],
        pagination: {
            pageIndex: response.data.pageIndex,
            pageSize: response.data.pageSize,
            totalRecord: response.data.totalRecord,
        },
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
}

export const AddAttributeValues = async (formData) => {
    const response = await api.post(endpoints.AttributeValues.AddAttributeValue, formData);
    return {
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
}

export const UpdateAttributeValue = async (id, formData) => {
    const response = await api.put(`${endpoints.AttributeValues.UpdateAttributeValue}/${id}`, formData);
    return {
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
}

export const DeleteAttributeValue = async (id) => {
    const response = await api.delete(`${endpoints.AttributeValues.DeleteAttributeValue}/${id}`);
    return {
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
}

const AttributeValuesService = {
    GetAllAttributeValue
};

export default AttributeValuesService;